import { ContentfulMicrocopy } from '@/data/Contentful/ContentfulGetMicrocopyListing';
import microcopyDefaultDictionary from '@/data/microcopy/microcopyDefaultDictionary';
import { MicrocopyKey } from '@/data/microcopy/microcopyDictionary';

export const getMicrocopyMap = (contentfulMicrocopy?: ContentfulMicrocopy[]) => {
  const microcopy = new Map<MicrocopyKey, string>(
    Object.entries(microcopyDefaultDictionary) as [MicrocopyKey, string][],
  );

  if (contentfulMicrocopy) {
    contentfulMicrocopy.forEach((item) => {
      microcopy.set(item.contentKey, item.content);
    });
  }

  return microcopy;
};
